import { render, staticRenderFns } from "./DiskComponent.vue?vue&type=template&id=408ff5a2&scoped=true&"
import script from "./DiskComponent.vue?vue&type=script&lang=js&"
export * from "./DiskComponent.vue?vue&type=script&lang=js&"
import style0 from "./DiskComponent.vue?vue&type=style&index=0&id=408ff5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408ff5a2",
  null
  
)

export default component.exports